import React from 'react'
import { Link } from 'react-router-dom'

const IconLink = props => {
    return (
        <Link to={props.to} className="group w-21.5 text-center mr-7.5">
                <div className="border bg-white text-sm border-vp-lightbrown group-hover:border-primary group-hover:bg-primary-light flex justify-center items-center rounded-md h-21.5" >
                {props.icon}
                </div>
                <div className="mt-2 text-sm font-bold group-hover:text-primary">{props.text}</div>
        </Link>
    )
}



export default IconLink
